export const ambassadorWithHeaders = (httpClient, controllerConfig, currency, errorHandler, shouldUseWithErrorHandler, errorCodesMap) => {
  const headers = getHeaders(controllerConfig, currency);
  if (shouldUseWithErrorHandler) {
    return req => {
      return errorHandler.withErrorHandler(() => httpClient.request(args => ({
        ...req(args),
        headers
      })), {
        errorCodesMap: errorCodesMap
      });
    };
  }
  return req => {
    return httpClient.request(args => ({
      ...req(args),
      headers
    }));
  };
};
export const getHeaders = (controllerConfig, currency) => {
  const currencyHeader = currency ? {
    'x-wix-currency': currency
  } : {};
  const multilingualHeader = getMultilingualHeader(controllerConfig);
  return {
    ...currencyHeader,
    ...multilingualHeader
  };
};
const getMultilingualHeader = controllerConfig => {
  const {
    multilingual
  } = controllerConfig.wixCodeApi.window;
  if (!(multilingual != null && multilingual.isEnabled)) {
    return {};
  }
  const currentLanguage = multilingual.siteLanguages.find(lang => lang.languageCode === multilingual.currentLanguage);
  if (!currentLanguage) {
    return {};
  }
  return {
    'x-wix-linguist': `${currentLanguage.languageCode}|${currentLanguage.locale}|${currentLanguage.isPrimaryLanguage.toString()}|${controllerConfig.appParams.instanceId}`
  };
};
//# sourceMappingURL=ambassador.utils.js.map